// extracted by mini-css-extract-plugin
export default {"EventMetrics":"EventMetrics_EventMetrics__dISJN","metricItem":"EventMetrics_metricItem__8Fr9u","num":"EventMetrics_num__E4HHa","label":"EventMetrics_label__7esPT"};